import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import SelectPlan from './pages/SelectPlan';
import Home from './pages/Home';
import Profile from './pages/Profile';
import AdminHome from './pages/AdminHome';
import LandingPage from './pages/Landing';
import HelpPage from './pages/Help';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent-primary" />
      </div>
    );
  }

  return user ? children : <Navigate to="/welcome" />;
};

const PublicRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent-primary" />
      </div>
    );
  }

  return user ? <Navigate to="/home" /> : children;
};

function App() {
  return (
    <AuthProvider>
       <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#16162A",
            color: "#fff",
            border: "1px solid #2A2A4A",
          },
          success: { iconTheme: { primary: "#4CAF50", secondary: "#fff" } },
          error: { iconTheme: { primary: "#FF5252", secondary: "#fff" } },
        }}
      />



      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public Routes */}
              <Route
              path="/welcome"
              element={
                <PublicRoute>
                  <LandingPage />
                </PublicRoute>
              }
            />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
              <Route
              path="/help"
              element={
                <PublicRoute>
                  <HelpPage />
                </PublicRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />
            <Route path="/select-plan" element={<SelectPlan />} />

            {/* Protected Routes */}
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
                <Route
              path="/adminhome"
              element={
                <ProtectedRoute>
                  <AdminHome />
                </ProtectedRoute>
              }
            />

            {/* Default Route */}
            <Route path="/" element={<Navigate to="/welcome" />} />
            <Route path="*" element={<Navigate to="/welcome" />} />
          </Routes>
              
          {/* Toast Notifications */}
       
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;